import { KonicaAPI } from "../index";

export const getUser = () => {
  try {
    const response = KonicaAPI.post("/my-account/details", {});
    return response;
  } catch (error) {
    return error;
  }
};

export const submitUser = (inputs) => {
  try {
    const response = KonicaAPI.post("/my-account/save", inputs);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submitEditUser = (inputs) => {
  try {
    const response = KonicaAPI.post("/user-management/edit", inputs);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const submitPassword = (inputs) => {
  try {
    const response = KonicaAPI.post("/my-account/edit-password", inputs);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const resendEmailVerification = (inputs) => {
  try {
    const response = KonicaAPI.post(
      "/my-account/resend-confirmation-email",
      inputs
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
